/**
 * CSV export utilities
 */

/**
 * Download data as a CSV file
 * @param filename - The name of the file to download (should end in .csv)
 * @param headers - Array of column header strings
 * @param rows - 2D array of row data (each inner array is a row)
 * @param meta - Optional preamble rows (e.g. applied filters) written above the
 *   header, followed by a blank separator line. Each inner array is one row.
 */
export function downloadCSV(filename: string, headers: string[], rows: string[][], meta?: string[][]): void {
  const escape = (cell: string) => `"${cell.replace(/"/g, '""')}"`;
  const lines: string[] = [];

  if (meta && meta.length > 0) {
    for (const row of meta) lines.push(row.map(escape).join(','));
    lines.push(''); // blank line separating metadata from the data table
  }

  lines.push(headers.join(','));
  for (const row of rows) lines.push(row.map(escape).join(','));

  const csvContent = lines.join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
  URL.revokeObjectURL(link.href);
}
